import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, WhatsappLogo, LinkSimple, Clock, Sun, MoonStars, X, Megaphone, BookOpen, CaretDown, InstagramLogo, YoutubeLogo, GraduationCap, Broadcast, ArrowSquareOut, Trash, PaperPlaneRight } from "@phosphor-icons/react";
import { api } from "@/lib/api";
import { LiteYouTube } from "@/components/LiteYouTube";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

const ytId = (url) => { const m = (url || "").match(/(?:youtube\.com\/(?:live\/|watch\?v=|embed\/)|youtu\.be\/)([\w-]{6,})/); return m ? m[1] : ""; };
const DAYS = ["Ahad", "Senin", "Selasa", "Rabu", "Kamis", "Jum'at", "Sabtu"];
const MON = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"];
const PRAYERS = [["Fajr", "Subuh"], ["Dhuhr", "Dzuhur"], ["Asr", "Ashar"], ["Maghrib", "Maghrib"], ["Isha", "Isya"]];

function GbMessage({ text }) {
  const [open, setOpen] = useState(false);
  const [clamped, setClamped] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (el) setClamped(el.scrollHeight > el.clientHeight + 1);
  }, [text]);
  return (
    <div>
      <p ref={ref} className={`text-stone-600 text-sm mt-0.5 whitespace-pre-line break-words ${open ? "" : "line-clamp-3"}`}>{text}</p>
      {(clamped || open) && (
        <button data-testid="gb-more" onClick={() => setOpen((v) => !v)} className="text-primary text-xs font-bold mt-0.5">{open ? "Sembunyikan" : "Selengkapnya"}</button>
      )}
    </div>
  );
}

export default function Informasi() {
  const navigate = useNavigate();
  const [info, setInfo] = useState(null);
  const [now, setNow] = useState(new Date());
  const [prayer, setPrayer] = useState(null);
  const [full, setFull] = useState(null);
  const trackRef = useRef(null);
  const [dot, setDot] = useState(0);
  const [openDoa, setOpenDoa] = useState(false);
  const [openDzikir, setOpenDzikir] = useState(false);
  const { user } = useAuth();
  const [links, setLinks] = useState([]);
  const [gb, setGb] = useState([]);
  const [gbForm, setGbForm] = useState({ name: "", address: "", message: "" });
  const [gbAll, setGbAll] = useState(false);
  const [gbBusy, setGbBusy] = useState(false);
  const loadGb = () => api.get("/guestbook").then((r) => setGb(r.data)).catch(() => {});

  useEffect(() => { api.get("/info-page").then((r) => setInfo(r.data)).catch(() => {}); }, []);
  useEffect(() => { api.post("/info-visit").catch(() => {}); }, []);
  useEffect(() => { api.get("/radio/links").then((r) => setLinks(r.data)).catch(() => {}); loadGb(); }, []);
  useEffect(() => { const t = setInterval(() => setNow(new Date()), 1000); return () => clearInterval(t); }, []);
  useEffect(() => {
    fetch("https://api.aladhan.com/v1/timingsByCity?city=Banda%20Aceh&country=Indonesia&method=20")
      .then((r) => r.json()).then((j) => setPrayer(j?.data?.timings || null)).catch(() => {});
  }, []);

  if (!info) return <div className="min-h-screen flex items-center justify-center bg-[#F9FBE7] text-primary font-semibold" data-testid="info-loading">Memuat…</div>;
  const photos = info.photos || [];
  const doa = (info.doa || []);
  const doaShahih = doa.filter((d) => !/dzikir/i.test(d.folder || ""));
  const dzikir = doa.filter((d) => /dzikir/i.test(d.folder || ""));
  const announcements = info.announcements || [];
  const kajian = links.filter((l) => l.type === "kajian");
  const liveLinks = links.filter((l) => l.type === "live" || l.type === "radio");
  const submitGb = async () => {
    if (!gbForm.name.trim() || !gbForm.message.trim()) { toast.error("Nama dan pesan wajib diisi"); return; }
    setGbBusy(true);
    try { await api.post("/guestbook", gbForm); setGbForm({ name: "", address: "", message: "" }); await loadGb(); toast.success("Terima kasih, pesan Anda menunggu persetujuan admin sebelum tampil"); }
    catch { toast.error("Gagal menyimpan pesan"); } finally { setGbBusy(false); }
  };
  const delGb = async (id) => { if (!window.confirm("Yakin mau dihapus?")) return; try { await api.delete(`/guestbook/${id}`); await loadGb(); } catch (e) {} };

  const onScroll = () => {
    const el = trackRef.current; if (!el) return;
    setDot(Math.round(el.scrollLeft / el.clientWidth));
  };
  const clock = `${String(now.getHours()).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}:${String(now.getSeconds()).padStart(2, "0")}`;

  return (
    <div className="min-h-screen flex justify-center bg-[#F9FBE7]">
      <div className="w-full md:max-w-md min-h-screen bg-[#F9FBE7] pb-10" data-testid="informasi-screen">
        <div className="bg-primary text-white px-5 pt-6 pb-6 rounded-b-[2rem] flex items-center gap-3">
          <button data-testid="info-back-btn" onClick={() => navigate("/welcome")} className="w-10 h-10 rounded-full bg-white/15 flex items-center justify-center active:scale-90 transition-transform">
            <ArrowLeft size={20} weight="bold" />
          </button>
          <img src="/mks_logo.png" alt="Muslim Kids School" className="w-11 h-11 rounded-lg bg-white/95 object-contain p-0.5" />
          <h1 className="font-heading font-bold text-lg">Muslim Kids School</h1>
        </div>

        <div className="px-5 mt-5 space-y-6">
          {/* Realtime clock */}
          <div className="bg-white rounded-2xl p-4 shadow-sm text-center" data-testid="info-clock">
            <p className="text-stone-500 text-sm">{DAYS[now.getDay()]}, {now.getDate()} {MON[now.getMonth()]} {now.getFullYear()}</p>
            <p className="font-heading font-bold text-3xl text-primary flex items-center justify-center gap-2 mt-1">
              <Clock size={26} weight="fill" /> {clock} <span className="text-sm text-stone-400 font-medium">WIB</span>
            </p>
          </div>

          {/* Prayer times */}
          <section data-testid="info-prayer-section">
            <h2 className="font-heading font-bold text-stone-800 mb-2">Jadwal Sholat • Banda Aceh</h2>
            <div className="grid grid-cols-5 gap-1.5">
              {PRAYERS.map(([k, l]) => (
                <div key={k} className="bg-white rounded-xl py-2.5 text-center shadow-sm border border-primary/10">
                  <p className="text-[11px] text-stone-500">{l}</p>
                  <p className="font-heading font-bold text-primary text-sm" data-testid={`prayer-${k}`}>{prayer ? (prayer[k] || "-").slice(0, 5) : "…"}</p>
                </div>
              ))}
            </div>
          </section>

          <section data-testid="info-text-section">
            <h2 className="font-heading font-bold text-stone-800 mb-2">Informasi</h2>
            <p className="text-stone-600 text-sm whitespace-pre-line leading-relaxed">{info.text}</p>
          </section>

          {/* Announcements */}
          {announcements.length > 0 && (
            <section data-testid="info-announcement-section">
              <h2 className="font-heading font-bold text-stone-800 mb-2 flex items-center gap-2"><Megaphone size={20} weight="duotone" className="text-secondary" /> Pengumuman</h2>
              <div className="space-y-3">
                {announcements.map((a, i) => (
                  <div key={i} data-testid={`info-ann-${i}`} className="bg-white rounded-2xl overflow-hidden shadow-sm border border-stone-200/60">
                    {a.poster && <img src={a.poster} alt="" className="w-full object-cover" />}
                    <div className="p-4">
                      {a.title && <p className="font-heading font-bold text-stone-800 mb-1">{a.title}</p>}
                      {a.text && <p className="text-stone-600 text-sm whitespace-pre-line leading-relaxed">{a.text}</p>}
                    </div>
                  </div>
                ))}
              </div>
            </section>
          )}

          {/* Dokumentasi Kegiatan Sekolah (carousel + fullscreen) */}
          {photos.length > 0 && (
            <section data-testid="info-gallery-section">
              <h2 className="font-heading font-bold text-stone-800 mb-2">Dokumentasi Kegiatan Sekolah</h2>
              <div ref={trackRef} onScroll={onScroll} className="flex gap-3 overflow-x-auto snap-x snap-mandatory no-scrollbar rounded-2xl" data-testid="info-carousel">
                {photos.map((p, i) => (
                  <img key={i} src={p} alt="dokumentasi" loading="lazy" onClick={() => setFull(p)}
                    className="w-full shrink-0 snap-center aspect-video object-cover rounded-2xl cursor-pointer active:scale-[0.99] transition-transform" data-testid={`info-photo-${i}`} />
                ))}
              </div>
              {photos.length > 1 && (
                <div className="flex justify-center gap-1.5 mt-2" data-testid="info-carousel-dots">
                  {photos.map((_, i) => (
                    <span key={i} className={`h-1.5 rounded-full transition-all ${dot === i ? "w-5 bg-primary" : "w-1.5 bg-stone-300"}`} />
                  ))}
                </div>
              )}
            </section>
          )}

          <section data-testid="info-registration-section">
            <h2 className="font-heading font-bold text-stone-800 mb-2">Pendaftaran</h2>
            {info.registration_url ? (
              <a href={info.registration_url} target="_blank" rel="noopener noreferrer"
                className="flex items-center gap-2 bg-primary text-white font-semibold px-4 py-3 rounded-2xl active:scale-95 transition-transform">
                <LinkSimple size={18} weight="bold" /> Formulir Pendaftaran
              </a>
            ) : <p className="text-stone-400 text-sm">Info pendaftaran segera hadir.</p>}
          </section>

          {info.videos?.length > 0 && (
            <section data-testid="info-video-section">
              <h2 className="font-heading font-bold text-stone-800 mb-2">Video Dokumentasi Kegiatan Sekolah</h2>
              <div className="flex gap-3 overflow-x-auto snap-x snap-mandatory no-scrollbar pb-1" data-testid="info-video-carousel">
                {[...info.videos].reverse().map((v, i) => ytId(v) && (
                  <div key={i} className="w-[85%] shrink-0 snap-center rounded-2xl overflow-hidden border border-stone-200/60 aspect-video bg-black">
                    <LiteYouTube id={ytId(v)} title={`video-${i}`} />
                  </div>
                ))}
              </div>
            </section>
          )}

          {/* Doa Shahih Harian & Dzikir sebagai link yang bisa dibuka */}
          <div className="space-y-3">
            <div>
              <button data-testid="info-doa-link" onClick={() => setOpenDoa((v) => !v)}
                className="w-full bg-white rounded-2xl p-4 shadow-sm border border-primary/10 flex items-center gap-3 active:scale-[0.99] transition-transform">
                <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center shrink-0"><BookOpen size={20} weight="duotone" className="text-primary" /></div>
                <span className="flex-1 text-left font-heading font-bold text-stone-800">Doa Shahih Harian</span>
                <CaretDown size={18} className={`text-stone-400 transition-transform ${openDoa ? "rotate-180" : ""}`} />
              </button>
              {openDoa && (
                <div className="space-y-3 mt-3" data-testid="info-doa-list">
                  {doaShahih.length ? doaShahih.map((d, i) => <DoaCard key={i} d={d} idx={i} tag="doa" />) : <p className="text-stone-400 text-sm text-center py-2">Belum ada doa.</p>}
                </div>
              )}
            </div>
            <div>
              <button data-testid="info-dzikir-link" onClick={() => setOpenDzikir((v) => !v)}
                className="w-full bg-white rounded-2xl p-4 shadow-sm border border-secondary/20 flex items-center gap-3 active:scale-[0.99] transition-transform">
                <div className="w-10 h-10 rounded-xl bg-secondary/15 flex items-center justify-center shrink-0"><Sun size={20} weight="duotone" className="text-secondary" /></div>
                <span className="flex-1 text-left font-heading font-bold text-stone-800">Dzikir Pagi Petang Sahih</span>
                <CaretDown size={18} className={`text-stone-400 transition-transform ${openDzikir ? "rotate-180" : ""}`} />
              </button>
              {openDzikir && (
                <div className="space-y-3 mt-3" data-testid="info-dzikir-list">
                  {dzikir.length ? dzikir.map((d, i) => <DoaCard key={i} d={d} idx={i} tag="dzikir" />) : <p className="text-stone-400 text-sm text-center py-2">Belum ada dzikir.</p>}
                </div>
              )}
            </div>
          </div>

          {(kajian.length > 0 || liveLinks.length > 0) && (
            <div className="space-y-4" data-testid="info-kajian-section">
              {kajian.length > 0 && (
                <div>
                  <div className="flex items-center gap-2 mb-2">
                    <GraduationCap size={20} weight="duotone" className="text-primary" />
                    <h2 className="font-heading font-bold text-stone-800">Kajian Parenting</h2>
                  </div>
                  <div className="space-y-3">
                    {kajian.map((l) => (
                      <div key={l.id} data-testid={`info-kajian-${l.id}`} className="bg-white rounded-2xl border border-stone-200/60 overflow-hidden shadow-sm">
                        <div className="relative w-full aspect-video bg-stone-900">
                          {ytId(l.url) ? <LiteYouTube id={ytId(l.url)} title={l.name} /> : (
                            <a href={l.url} target="_blank" rel="noopener noreferrer" className="absolute inset-0 flex items-center justify-center text-white gap-2"><YoutubeLogo size={26} weight="fill" className="text-red-500" /> Buka video</a>
                          )}
                        </div>
                        <p className="font-semibold text-stone-800 text-sm px-3 py-2.5 line-clamp-2">{l.name}</p>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {liveLinks.length > 0 && (
                <div>
                  <div className="flex items-center gap-2 mb-2">
                    <Broadcast size={20} weight="duotone" className="text-primary" />
                    <h2 className="font-heading font-bold text-stone-800">TV &amp; Radio Dakwah</h2>
                  </div>
                  <div className="space-y-2">
                    {liveLinks.map((l) => (
                      <div key={l.id} data-testid={`info-live-${l.id}`} className="bg-white rounded-2xl border border-stone-200/60 overflow-hidden shadow-sm">
                        {ytId(l.url) && <div className="relative w-full aspect-video bg-stone-900"><LiteYouTube id={ytId(l.url)} title={l.name} /></div>}
                        <div className="p-3 flex items-center gap-3">
                          <div className="w-9 h-9 rounded-xl bg-red-100 flex items-center justify-center shrink-0"><YoutubeLogo size={20} weight="fill" className="text-red-600" /></div>
                          <p className="flex-1 min-w-0 font-semibold text-stone-800 text-sm line-clamp-2">{l.name}</p>
                          <a href={l.url} target="_blank" rel="noopener noreferrer" data-testid={`info-live-link-${l.id}`} className="shrink-0 bg-red-600 text-white font-bold text-xs px-3 py-2 rounded-full flex items-center gap-1 active:scale-95 transition-transform">Buka <ArrowSquareOut size={13} weight="bold" /></a>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}

          <a data-testid="info-whatsapp-btn" href={`https://wa.me/${(info.whatsapp || "").replace(/[^0-9]/g, "")}`} target="_blank" rel="noopener noreferrer"
            className="flex items-center justify-center gap-2 bg-green-600 text-white font-heading font-bold text-lg py-4 rounded-full shadow-lg active:scale-95 transition-transform">
            <WhatsappLogo size={24} weight="fill" /> Tanya via WhatsApp
          </a>

          {info.instagram_url && (
            <div data-testid="info-instagram-section" className="text-center">
              <a data-testid="info-instagram-btn" href={info.instagram_url} target="_blank" rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 text-white font-heading font-bold text-base py-3.5 rounded-full shadow-lg active:scale-95 transition-transform"
                style={{ background: "linear-gradient(90deg,#f58529,#dd2a7b,#8134af)" }}>
                <InstagramLogo size={22} weight="fill" /> Instagram
              </a>
              {info.instagram_text && <p className="text-stone-600 text-sm mt-1.5 whitespace-pre-line">{info.instagram_text}</p>}
            </div>
          )}
          {info.youtube_url && (
            <div data-testid="info-youtube-section" className="text-center">
              <a data-testid="info-youtube-btn" href={info.youtube_url} target="_blank" rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 bg-red-600 text-white font-heading font-bold text-base py-3.5 rounded-full shadow-lg active:scale-95 transition-transform">
                <YoutubeLogo size={22} weight="fill" /> YouTube
              </a>
              {info.youtube_text && <p className="text-stone-600 text-sm mt-1.5 whitespace-pre-line">{info.youtube_text}</p>}
            </div>
          )}

          <div data-testid="info-guestbook" className="pt-2">
            <div className="flex items-center gap-2 mb-2">
              <BookOpen size={20} weight="duotone" className="text-primary" />
              <h2 className="font-heading font-bold text-stone-800">Buku Tamu</h2>
            </div>
            <div className="bg-white rounded-2xl p-4 shadow-sm border border-stone-200/60 space-y-2">
              <input data-testid="gb-name" value={gbForm.name} onChange={(e) => setGbForm({ ...gbForm, name: e.target.value })} placeholder="Nama" className="w-full bg-stone-50 border border-stone-200 rounded-xl py-2.5 px-3 text-sm outline-none focus:border-primary" />
              <input data-testid="gb-address" value={gbForm.address} onChange={(e) => setGbForm({ ...gbForm, address: e.target.value })} placeholder="Alamat" className="w-full bg-stone-50 border border-stone-200 rounded-xl py-2.5 px-3 text-sm outline-none focus:border-primary" />
              <textarea data-testid="gb-message" value={gbForm.message} onChange={(e) => setGbForm({ ...gbForm, message: e.target.value })} placeholder="Pesan / kesan" rows={3} className="w-full bg-stone-50 border border-stone-200 rounded-xl py-2.5 px-3 text-sm outline-none focus:border-primary resize-none" />
              <button data-testid="gb-submit" onClick={submitGb} disabled={gbBusy} className="w-full bg-primary text-white font-heading font-bold py-2.5 rounded-full flex items-center justify-center gap-2 active:scale-95 transition-transform disabled:opacity-60"><PaperPlaneRight size={17} weight="fill" /> Kirim</button>
            </div>
            {gb.length > 0 && (
              <div className="mt-3 space-y-2" data-testid="gb-list">
                {(gbAll ? gb : gb.slice(0, 3)).map((g) => (
                  <div key={g.id} data-testid={`gb-item-${g.id}`} className="bg-white rounded-2xl p-3 shadow-sm border border-stone-200/60">
                    <div className="flex items-start justify-between gap-2">
                      <div className="min-w-0">
                        <p className="font-heading font-bold text-stone-800 text-sm truncate">{g.name}{g.address ? <span className="text-stone-400 font-normal"> · {g.address}</span> : null}</p>
                        <GbMessage text={g.message} />
                        <p className="text-stone-400 text-[11px] mt-1">{new Date(g.created_at).toLocaleDateString("id-ID", { day: "numeric", month: "short", year: "numeric" })}</p>
                      </div>
                      {user?.role === "admin" && <button data-testid={`gb-del-${g.id}`} onClick={() => delGb(g.id)} className="shrink-0 text-stone-300 hover:text-red-500"><Trash size={16} /></button>}
                    </div>
                  </div>
                ))}
                {gb.length > 3 && (
                  <button data-testid="gb-toggle" onClick={() => setGbAll((v) => !v)} className="w-full text-primary text-sm font-bold py-1">{gbAll ? "Sembunyikan" : `Tampilkan semua (${gb.length})`}</button>
                )}
              </div>
            )}
          </div>
        </div>

        {full && (
          <div className="fixed inset-0 z-[80] bg-black/90 flex items-center justify-center p-4" data-testid="info-fullscreen" onClick={() => setFull(null)}>
            <button data-testid="info-fullscreen-close" className="absolute top-4 right-4 w-11 h-11 rounded-full bg-white/20 text-white flex items-center justify-center"><X size={22} weight="bold" /></button>
            <img src={full} alt="dokumentasi" className="max-w-full max-h-full rounded-xl object-contain" />
          </div>
        )}
      </div>
    </div>
  );
}

function DoaCard({ d, idx, tag }) {
  return (
    <div data-testid={`info-${tag}-${idx}`} className="bg-white rounded-2xl p-4 shadow-sm border border-stone-200/60">
      {d.label && <p className="font-heading font-semibold text-stone-800 text-sm mb-1">{d.label}</p>}
      {d.arabic && <p className="font-arabic text-2xl text-right text-stone-800 leading-loose" dir="rtl">{d.arabic}</p>}
      {d.latin && <p className="text-primary/80 italic text-xs mt-1">{d.latin}</p>}
      {d.translation && <p className="text-stone-600 text-xs mt-1">{d.translation}</p>}
      {d.source && <p className="text-stone-400 text-[11px] mt-1">{d.source}</p>}
    </div>
  );
}
